import React from 'react'

import './FocusReactions.scss'

const FocusReactions = () => {
  return (
    <div className="focus-widget focus-reactions">
      {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
      <span>1&thinsp;👍</span>
      {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
      <span>2&thinsp;😃</span>
      {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
      <span>1&thinsp;❤️</span>
      {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
      <span>1&thinsp;👏</span>
      {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
      <span>1&thinsp;💡</span>
    </div>
  )
}
export { FocusReactions }
